class ShowValueField extends HTMLElement {
	selectors = {
		input: '[data-js-input]',
		button: '[data-js-button]',
	};
	constructor() {
		super();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.inputElement = this.querySelector(this.selectors.input);
		this.buttonElement = this.querySelector(this.selectors.button);

		if (!this.inputElement && !this.buttonElement) {
			return;
		}

		this.buttonElement.addEventListener('click', this.onButtonClick);
	}

	onButtonClick = () => {
		const isVisible = this.inputElement.type !== 'password';

		if (isVisible) {
			this.buttonElement.classList.remove('is-visible');

			this.inputElement.type = 'password';
		} else {
			this.buttonElement.classList.add('is-visible');

			this.inputElement.type = 'text';
		}
	};
}

customElements.define('show-value-field', ShowValueField);
